export enum DeepLinkAction {
  qrCodeAuth = 'qrCodeAuth',
  qrCodeAutoAuth = 'qrCodeAutoAuth',
  ecc = 'ecc', // employer connect code
  logout = 'logout', // triggers a logout in the app
}
